import React, { Component } from "react";
import Slider from "react-slick";

import faq1 from '../assets/for-employers/FAQ-Implement.svg';
import faq2 from '../assets/for-employers/FAQ-bilingual.svg';
import faq3 from '../assets/for-employers/FAQ-lost-card.svg';
import faq4 from '../assets/for-employers/FAQ-cash.svg';


export default class CarouselSlider extends Component {

  constructor(props) {
    super(props);
    this.pauseAutoplay = this.pauseAutoplay.bind(this);
  }
  pauseAutoplay() {
    this.slider.slickPause();
  }
  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000
    };
    return (
      <div onTouchStart={this.pauseAutoplay} className="slider-contain">
        <Slider ref={slider => (this.slider = slider)} {...settings}>
          <div className="carousel-item">
            <div className="carousel-item-background">
              <div className="carousel-item-text-wrapper">
                <p className="section-header">Does the Fintwist Payroll Card program cost me anything?</p>
                <p className="section-body">Our program is 100% free of cost to most employers.</p>
              </div>
              <img src={faq1} alt="" />
            </div>
          </div>
          <div className="carousel-item">
            <div className="carousel-item-background">
              <div className="carousel-item-text-wrapper">
                <p className="section-header">Do you offer bilingual support?</p>
                <p className="section-body">We sure do! And 24/7 phone support for your employees!</p>
              </div>
              <img src={faq2} alt="" />
            </div>
          </div>
          <div className="carousel-item">
            <div className="carousel-item-background">
              <div className="carousel-item-text-wrapper">
                <p className="section-header">What if an employee loses their card?</p>
                <p className="section-body">We’ll teach you how to replace a lost card in minutes using your instant issue cards or we can manage the process for you.</p>
              </div>
              <img src={faq3} alt="" />
            </div>
          </div>
          <div className="carousel-item">
            <div className="carousel-item-background">
              <div className="carousel-item-text-wrapper">
                <p className="section-header">How can my employees get cash?</p>
                <p className="section-body">With Fintwist, your employees have access to over 58,000 ATMs nationwide through the AllPoint Network, which provides unlimited free cash withdrawals.</p>
              </div>
              <img src={faq4} alt="" />
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}